import PhotoHero from "./PhotoHero";

export default PhotoHero;